const baseURL = '/slack';

async function getInstallInfo() {
    return axios.get(`${baseURL}/installInfo`).then(R.prop('data'));
}

async function installApp(accountId) {
    window.open(
        `${process.env.VUE_APP_API_URL}/slack/install?accountId=${accountId}`,
        '_blank'
    );
}

export default {
    getInstallInfo,
    installApp,
};
